import importXML from "@/modules/importXML";
export const switchEditor = ({ commit }, payload) => {
  commit("switchEditor", payload);
};
export const switchInlayBackground = ({ commit, getters }, payload) => {
  commit("switchBackground", payload);
  saveInlay({ commit, getters });
};
export const switchInlayBackgroundImg = ({ commit, getters }, payload) => {
  if (getters.currentInlay.group != "gt6l") {
    commit("switchBackgroundImg", payload);
  } else {
    commit("switchGT6LBackgroundImg", payload);
  }
  saveInlay({ commit, getters });
};
export const displayBackgroundImg = ({ commit, getters }, payload) => {
  commit("displayBackgroundImg", payload);
  saveInlay({ commit, getters });
};
export const selectBtns = ({ commit }, payload) => {
  commit("selectBtns", payload);
};
export const transformBgImg = ({ commit, getters }, payload) => {
  commit("transformBgImg", payload);
  saveInlay({ commit, getters });
};
export const repositionBg = ({ commit, getters }, payload) => {
  commit("repositionBg", payload);
  saveInlay({ commit, getters });
};
export const setLEDrad = ({ commit, getters }, payload) => {
  commit("setLEDradius", payload);
  saveInlay({ commit, getters });
};
export const toggleLEDs = ({ commit, getters }, payload) => {
  commit("showLED", payload);
  payload ? commit("displayLEDs", "block") : commit("displayLEDs", "none");
  saveInlay({ commit, getters });
};
export const toggleBarG = ({ commit, getters }, payload) => {
  if (getters.selectedBarG.length < 1) {
    selectBarG({ commit, getters }, "BargraphLED");
  }
  commit("showBarG", payload);
  saveInlay({ commit, getters });
};
export const toggleBarGCaptions = ({ commit }, payload) => {
  commit("showBarGCaptions", payload);
};
export const selectBarG = ({ commit, getters }, payload) => {
  let selected = getters.currentInlay.inlay.bargraph.filter(
    (graph) => graph.type == payload
  );
  commit("selectBarG", selected);
  saveInlay({ commit, getters });
};
//Function to import Inlays from XML to more usable JSON format
//Imports all Known XMLs
export const importXMLs = async ({ commit }) => {
  importXML().then((response) => {
    commit("setInlays", response);
  });
};
export const setCurrentInlay = ({ commit }, payload) => {
  commit("setCurrentInlay", payload);
};
export const setProjectName = ({ commit }, payload) => {
  commit("setCurrentProjectName", payload);
};
export const addInlayToProject = ({ getters, commit }, payload) => {
  getters.currentProject.forEach((inlay) => {
    if (inlay["project-name"] == payload["project-name"]) {
      payload["project-name"] += "_copy";
    }
  });

  commit("addInlayToProject", payload);
};
export const changeButtonStyle = ({ commit, getters }, payload) => {
  commit("setButtonStyle", payload);
  saveInlay({ commit, getters });
};
export const saveInlay = ({ commit, getters }) => {
  //console.log(getters.currentInlay);
  commit("saveInlay", getters.currentInlay);
};
export const undoSaveInlay = ({ commit, getters }) => {
  getters.inlaySave.pop();
  if (getters.inlaySave.length > 0)
    setCurrentInlay(
      { commit },
      getters.inlaySave[getters.inlaySave.length - 1]
    );
};
export const hasBargraph = ({ getters }) => {
  return getters.currentInlay.inlay.bargraph.length > 0;
};
export const addText = ({ commit }) => {
  commit("addDraggableText");
};
export const dragText = ({ commit }, payload) => {
  commit("draggingText", payload);
};
export const removeInlay = ({ commit }, payload) => {
  // let newPrjt = getters.currentProject.slice(payload);
  commit("removeInlayFromProject", payload);
};
// export const addInlayToProject =({commit}, payload) = {
//   commit("addInlayToProject", payload)
// }
export const changeBargraphColor = ({ commit }, payload) => {
  commit("setBargraphBackground", payload);
};
export const switchGTBackground = ({ commit }, payload) => {
  commit("setGtBackground", payload);
};
export const changeInlayName = ({ commit }, payload) => {
  commit("setInlayName", payload);
};
